import { Filter } from "@/modules/Dashboards/AdminDashboard/models/Filter";
import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { OPERATORS_FILTERS } from "@/shared/constants/GeneralConstants";
import { FILTER_DISPLAY } from "@/modules/Dashboards/AdminDashboard/constants/AdminDashboardConstants";
import {
  SERVICE_TEMP_CONSTANTS,
  SERVICE_STATE
} from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import {
  FIXED_ORDER_FIELD_NAMES,
  ORDER_CONSTANTS
} from "@/modules/Orders/constants/OrderConstants";
import { GeneralRule } from "../models/GeneralRule";
import { FORM_CATEGORY } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { GenaralRuleField } from "../models/GenaralRuleField.model";
import { FIELD_GROUP_CONSTANTS } from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { RequestInnerInfo } from "../models/RequestInnerInfo.model";

export const KEY_PROPERTY = "key";

export const ORDER = "order";

export const DATA_TYPES = {
  STRING: "string"
};

export const INPUT_TYPE = {
  SELECT: "select",
  DATE_PICKER: "datePicker",
  TEXT: "text",
  NUMBER: "number",
  SLIDER: "slider",
  INPUT: "input",
  INTEGER: "integer",
  PHONE: "phone"
};

export const APPOINMENT_DATE = { name: "Fecha cita", key: "start" };
export const MODIFIED_DATE = { name: "Fecha modificación", key: "dateChanged" };
export const CREATED_DATE = { name: "Fecha creación", key: "dateCreated" };
export const COMPLETED_DATE = {
  name: "Fecha completado",
  key: "dateCompleted"
};

export const TIME_ELAPSED = {
  name: "Tiempo transcurrido",
  key: "timeElapsed"
};

export const QUERY_USER_SERVICE = {
  USER: { state: "Activo" },
  PATIENT: { state: "Activo", dependency: ["Paciente"] },
  DOCTOR: { state: "Activo", dependency: ["Personal asistencial"] }
};

export const FILTERS_ACTIVE_ORDER = ["services", "sessions"];

export const STATUS_FIELD_NAME = "Estado";
export const FILTERS_NAMES_CONST = {
  TIME_ELAPSED,
  MEDICAL_APPOIMENT: {
    KEY: "medicalAppointments",
    NAME: "Cita médica",
    FIELDS: {
      START_DATE: APPOINMENT_DATE,
      CREATED_DATE: CREATED_DATE,
      PATIENT: { name: "Paciente", key: "patient" },
      DOCTOR: { name: "Doctor", key: "doctor" },
      SERVICE: { name: "Servicio", key: "serviceTemplate" },
      STATE: { name: "Estado", key: "state" },
      CAMPUS: { name: "Sede", key: "campus" },
      SPACE: { name: "Espacio físico", key: "space" },
      CREATED_BY: { name: "Creado por", key: "createdBy" }
    }
  },
  SERVICE: {
    KEY: "services",
    NAME: "Servicio",
    FIELDS: {
      TYPE: { name: "Tipo", key: "type" },
      CATEGORY: { name: "Categoría", key: "category" },
      USER: { name: "Usuario", key: "user" },
      PROGRESS: { name: "Progreso", key: "progress" },
      SERVICE_TEMPLATE: {
        name: "Plantilla (Nombre)",
        key: "serviceTemplate"
      },
      CUPS: { name: "Cups", key: "cups" },
      PRICE_LEVEL: { name: "Nivel de precio", key: "priceLevel" },
      STATUS: { name: "Estado", key: "state" },
      GROUP_LEVEL: { name: "Grupo o nivel", key: "groupsFilled" },
      STATE_GROUP_LEVEL: {
        name: "Estado del grupo o nivel",
        key: "groupState"
      },
      SESSION_TEMPLATE: {
        name: "Sesión",
        key: "sessionTemplate"
      },
      SESSION_STATE: { name: "Estado de la Sesión", key: "sessionState" },
      COMPLETED_DATE: COMPLETED_DATE,
      CREATED_DATE: CREATED_DATE,
      MODIFIED_DATE: MODIFIED_DATE,
      INACTIVITY_TIME: {
        name: "Tiempo de Inactividad",
        key: "inactivityTime"
      },
      TIME_LAST_SESSION: {
        name: "Tiempo desde última sesión",
        key: "timeLastSession"
      }
    }
  },
  USER: {
    KEY: "users",
    NAME: "Usuario",
    FIELDS: {
      STATUS: { name: "Estado", key: "state" },
      USERTEMPLATE: { name: "Plantilla (Nombre)", key: "userTemplate" },
      ROLE: { name: "Rol", key: "roles" },
      DEPENDENCY: { name: "Dependencia", key: "dependencies" },
      CREATED_DATE: CREATED_DATE,
      MODIFIED_DATE: MODIFIED_DATE
    }
  },
  FORM: {
    KEY: "forms",
    NAME: "Formulario",
    FIELDS: {
      FORMTEMPLATE: { name: "Plantilla", key: "formTemplate" },
      OWNER: {
        name: "Propietario (Usuario que diligencia)",
        key: "owner"
      },
      SERVICE: { name: "Servicio", key: "service" },
      CATEGORY: { name: "Categoría", key: "category" },
      CREATED_DATE: CREATED_DATE,
      COMPLETED_DATE: COMPLETED_DATE
    }
  },
  TASK: {
    KEY: "tasks",
    NAME: "Tarea",
    FIELDS: {
      ROLE: { name: "Rol", key: "idRole" },
      ASSIGNED: { name: "Usuario asignado", key: "assigned" },
      PATIENT: { name: "Usuario", key: "patient" },
      STATUS: { name: "Estado", key: "state" },
      NAME: { name: "Nombre", key: "name" },
      FORMTEMPLATE: { name: "Plantilla formulario", key: "formTemplate" },
      DEPENDENCY: { name: "Dependencia", key: "dependencies" },
      CREATED_DATE: CREATED_DATE,
      COMPLETED_DATE: COMPLETED_DATE
    }
  },
  ORDER: {
    KEY: "medicalOrders",
    NAME: "Orden",
    FIELDS: {
      STATUS: { name: "Estado", key: "state" },
      USER: { name: "Usuario", key: "user" },
      CUPS: { name: "Cups", key: "cups" },
      PRICE_LEVEL: { name: "Nivel de precio", key: "priceLevel" },
      PAYMENT_METHOD: { name: "Tipo de facturación", key: "billType" },
      CAMPUS: { name: "Campus", key: "campus" },
      PAYMENT: { name: "Pago", key: "payment" },
      DIAGNOSIS_CODE: {
        name: "Código de diagnóstico",
        key: "diagnosticPrimaryCode"
      },
      ORDER_TYPE: { name: "Tipo de orden", key: "orderType" },
      CREATED_DATE: CREATED_DATE
    }
  },
  SESSION: {
    KEY: "sessions",
    NAME: "Sesión",
    FIELDS: {
      SESSIONTEMPLATE: {
        name: "Plantilla (Nombre)",
        key: "sessionTemplate"
      },
      STATUS: { name: "Estado", key: "state" },
      OWNER: {
        name: "Propietario (Usuario que diligencia)",
        key: "owner"
      },
      SERVICE: { name: "Servicio", key: "serviceTemplate" },
      RATE: { name: "Calificación", key: "qualification" },
      CREATED_DATE: CREATED_DATE,
      COMPLETED_DATE: COMPLETED_DATE,
      TIME_BETWEEN: {
        name: "Tiempo Entre Sesiones",
        key: "timeBetweenSessions"
      }
    }
  },
  LEAD: {
    KEY: "leads",
    NAME: "Prospectos",
    FIELDS: { TYPE: { name: "Tipo", key: "type" } }
  }
};

export const PRICE_LEVEL = "Nivel de precio";
export const CUPS = "Cups";
export const UNDEFINED = undefined;

export const TASK_FIELDS = {
  FORM: "Seleccione formulario"
};

export const DATA_CONDITIONS_TRANSFER = ["Servicio", "Plantilla (Nombre)"];

export const GENERAL_RULES_FILTERS_LIST = {
  MAIN: {
    mainFilterKey: "name",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    secondaryFilters: [] as SecondaryFilter[],
    initial: true,
    placeholder:
      "Escriba el nombre del usuario o utiliza los filtros para agrupar información"
  },
  SECONDARY: {
    NAME: {
      name: "Nombre",
      placeholder: "Nombre de Regla",
      key: "name",
      avatar: "mdi-form-textbox",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "unique"
    },
    STATE: {
      name: "Estado",
      placeholder: "Estado de Regla",
      key: "state",
      avatar: "mdi-list-status",
      type: "secondaryFilter",
      default: true,
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { name: "Activo", key: "true" },
        { name: "Inactivo", key: "false" }
      ]
    },
    COLLECTION: {
      name: "Colección",
      placeholder: "Colección de Regla",
      key: "collection",
      avatar: "mdi-checkbox-multiple-blank",
      type: "secondaryFilter",
      disabled: false,
      operators: OPERATORS_FILTERS,
      display: "list",
      options: [
        { name: "Servicios", key: "services" },
        { name: "Ordenes", key: "medicalOrders" },
        { name: "Usuarios", key: "users" },
        { name: "Formularios", key: "forms" },
        { name: "Tareas", key: "tasks" },
        { name: "Citas Medicas", key: "medicalAppointments" },
        { name: "Sesiones", key: "sessions" }
      ]
    }
  }
};

export const SAVE_GENERAL_RULE_ID = "saveGeneralRules";

export const MEDICAL_ORDER_LABELS_FORM = {
  SERVICE_TYPE: "Servicio",
  PRICE_LEVEL: `${FIXED_ORDER_FIELD_NAMES.PRICE_LEVEL}:`,
  BYLLING_TYPE: `${FIXED_ORDER_FIELD_NAMES.BILL_TYPE}:`,
  STATE: `${FIXED_ORDER_FIELD_NAMES.STATE}:`,
  ORDER_TYPE: `${FIXED_ORDER_FIELD_NAMES.ORDER_TYPE}:`,
  CANCEL_VALUE: `${FIXED_ORDER_FIELD_NAMES.CANCEL_VALUE}:`,
  CAMPUS: `${FIXED_ORDER_FIELD_NAMES.CAMPUS}:`,
  DESCRIPTION: `${FIXED_ORDER_FIELD_NAMES.DESCRIPTION}:`,
  EVENT: `${FIXED_ORDER_FIELD_NAMES.EVENT}:`
};

export const ORDER_FORM_LABELS = {
  TITLE: "Parametros órden",
  DAYS_TO_APPLY_LABEL: "Generar órden en cantidad de días",
  CANCEL: "Cancelar",
  SAVE: "Guardar"
};

export const REQUIRED_PROPERTIES_TASK = ["name", "dependencies"];

export const TASK_FORM_LABELS = {
  TASK_CONFIGURATION: "Configuración tarea",
  TASK_NAME_LABEL: "Nombre de la tarea",
  DAYS_TO_APPLY: "Generar tarea en cantidad de días",
  WRITE_NUMBER: "Escribe un número",
  LIST_LOADING: "Cargando lista...",
  SELECT_VALUE: "Seleccione valor",
  SELECT_DATE: "Selecciona fecha y hora",
  FORM: "formulario",
  USERS: "usuarios",
  CANCEL: "Cancelar",
  SAVE: "Guardar"
};

export const CUSTOM_FIELDS_LABELS_FORM = {
  RADIO: "radio",
  LIST: "lista",
  CHECKBOX_TYPE: "checkbox",
  STRING_TYPE: "string",
  SWITCH_TYPE: "switch",
  BASIC: "basico",
  SLIDER: "slider",
  EXIST_FIELD: "Este campo ya existe"
};

export const DOCUMENT_SECONDARY_FILTERS: SecondaryFilter[] = [
  {
    name: "Nombre",
    key: "idFormTemplate",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    default: true
  },
  {
    name: "Colección",
    key: "idFormTemplate",
    avatar: "mdi-form-textbox",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    default: true
  },
  {
    name: "Estado",
    key: "status",
    avatar: "mdi-list-status",
    type: "secondaryFilter",
    disabled: true,
    operators: OPERATORS_FILTERS,
    display: FILTER_DISPLAY.LIST,
    options: [
      { name: "Activo", key: "Activo" },
      { name: "Inactivo", key: "Inactivo" }
    ]
  }
];

export const GENERAL_RULES_FILTERS_LIST_: Filter[] = [
  {
    mainFilterKey: "forms",
    mainFilterName: "Todos",
    avatar: "mdi-animation",
    initial: true,
    secondaryFilters: DOCUMENT_SECONDARY_FILTERS
  }
];

export const TABS = {
  CONDITIONS: "CONDITIONS",
  ACTIONS: "ACTIONS"
};

export const ACTIONS = {
  ADD_RULE: "Crear regla",
  CANCEL: "Cancelar"
};

export const BELONGS_OPERATOR = { operator: "Pertenece a", key: "belongs" };
export const INCLUDE_OPERATOR = { operator: "Dentro de", key: "includes" };
export const EQUAL_OPERATOR = { operator: "Igual a", key: "==" };
export const GREATER_THAN_OPERATOR = { operator: "Mayor que", key: ">" };
export const LESS_THAN_OPERATOR = { operator: "Menor que", key: "<" };
export const BETWEEN_OPERATOR = { operator: "Entre", key: "between" };
export const LESS_THAN_OR_EQUALS_TO_OPERATOR = {
  operator: "Menor igual que",
  key: "<="
};
export const GREATER_THAN_OR_EQUALS_TO_OPERATOR = {
  operator: "Mayor igual que",
  key: ">="
};
export const DIFFERENT_TO_OPERATOR = {
  operator: "Diferente de",
  key: "!="
};

export const EQUAL_AND_INCLUDES_OPERATORS = [EQUAL_OPERATOR, INCLUDE_OPERATOR];

export const SEVERAL_OPERATORS = [
  EQUAL_OPERATOR,
  LESS_THAN_OPERATOR,
  LESS_THAN_OR_EQUALS_TO_OPERATOR,
  GREATER_THAN_OPERATOR,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR
];

export const GENERAL_OPERATORS = [
  EQUAL_OPERATOR,
  LESS_THAN_OPERATOR,
  LESS_THAN_OR_EQUALS_TO_OPERATOR,
  GREATER_THAN_OPERATOR,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR,
  DIFFERENT_TO_OPERATOR
];

export const STRING_OPERATORS = [EQUAL_OPERATOR, DIFFERENT_TO_OPERATOR];

const OPERATORS_GREATHER_LESS_THAN = [
  { operator: "Menor a", key: "<" },
  { operator: "Mayor a", key: ">" }
];

export const SEVERAL_OPERATORS_AND_RANGE = [
  EQUAL_OPERATOR,
  LESS_THAN_OPERATOR,
  LESS_THAN_OR_EQUALS_TO_OPERATOR,
  GREATER_THAN_OPERATOR,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR,
  BETWEEN_OPERATOR
];

export const TIME_ELAPSED_OPERATORS = [
  GREATER_THAN_OPERATOR,
  LESS_THAN_OPERATOR
];

export const INCLUDE_OPERATOR_NAME = "Dentro de";

export const SESION_STATUS_VALUES = [
  { key: "Completado", name: "Completado" },
  { key: "En progreso", name: "En progreso" },
  { key: "Asignado", name: "Asignado" }
];

export const SERVICE_STATE_LIST = SERVICE_STATE.sections.map(
  (state: string) => {
    return { key: state, name: state };
  }
);

export const STATUS_TASK = [
  { key: "Pendiente", name: "Pendiente" },
  { key: "Cancelada", name: "Cancelada" },
  { key: "Completada", name: "Completada" }
];

export const REQUIRED_PROPERTIES_ORDER = ["service", "state"];

export const USER_STATES = [
  { key: "Activo", name: "Activo" },
  { key: "Inactivo", name: "Inactivo" }
];

export const ORDER_STATUS = [
  { key: "Anulada", name: "Anulada" },
  { key: "Autorizada", name: "Autorizada" },
  { key: "Factura", name: "Factura" },
  { key: "Asignada", name: "Asignada" },
  { key: "Completada", name: "Completada" },
  { key: "Nueva", name: "Nueva" },
  { key: "Por revisar", name: "Por revisar" }
];

export const BILLING_TYPE = [
  { key: "Efectivo", name: "Efectivo" },
  { key: "Tarjeta", name: "Tarjeta" }
];

export const FORM_CATEGORY_LIST = FORM_CATEGORY.map(item => {
  const objectMapped = { key: "", name: "" };
  objectMapped.key = item;
  objectMapped.name = item;
  return objectMapped;
});

export const SERVICE_TYPE = SERVICE_TEMP_CONSTANTS.SERVICE_TYPE_LIST.map(
  item => {
    const objectMapped = { key: "", name: "" };
    objectMapped.key = item.value;
    objectMapped.name = item.label;
    return objectMapped;
  }
);

export const ORDER_TYPES = ORDER_CONSTANTS.ORDER_TYPE.map(item => {
  const objectMapped = { key: "", name: "" };
  objectMapped.key = item;
  objectMapped.name = item;
  return objectMapped;
});
export const USER_CONDITION = {
  key: FILTERS_NAMES_CONST.TASK.FIELDS.PATIENT.key,
  field: FILTERS_NAMES_CONST.TASK.FIELDS.PATIENT.name,
  operators: EQUAL_AND_INCLUDES_OPERATORS,
  display: INPUT_TYPE.SELECT,
  showInStopConditios: false
};

export const GENERAL_RULES_CONSTANTS = {
  ACTIVO: "Activo",
  DOC_REF: "docref",
  SERVICIO: "Servicio",
  ID: "id",
  ID_REFERENCE: "idReference",
  KEY: "key",
  _KEY: "_key",
  SESION: "Sesión",
  SESSIONES: "sessiones",
  DOCUMENTS: "actionPlan",
  GROUPS: "groups",
  GRUPOS: "Grupos",
  ACTION_PLAN_CATEGORY: "Categorías plan de accion",
  ACTION_PLAN: "Plan de acción",
  CHANGE_SERVICE_STATE: "Cambiar estado de servicio",
  NOTIFICATION: "notification",
  SELECT_FIELD: "Seleccione campo",
  CUSTOM_FIELDS: "Personalizados",
  MEDICAL_ORDER: "medicalOrder",
  CHANGE_MEDICAL_ORDER: "changeMedicalOrder",
  TASK: "task",
  FORM: "form",
  SERVICE: "service",
  LEAD: "leads",
  RPA: "rpa",
  RDA: "rda",
  CHANGE_SERVICE_STATE_ACTION: "changeServiceState",
  RPA_DESCRIPTION: "Ejecutar RPA para SURA",
  RDA_DESCRIPTION: "Ejecutar RDA",
  RPA_DISABLED: "Acción disponible sólo para la condición de Orden",
  TASK_DISABLED:
    "La acción no está disponible para las condiciones de formularios o sesiones",
  CHANGE_MEDICAL_ORDER_DISABLED:
    "Acción disponible solo para condiciones de Servicio y Cita Médica",
  ACTION_NOT_AVAILABLE: "Acción no disponible para esta colección",
  ACTION_TYPE: "Tipo de acción",
  COLECTIONS: "colecciones",
  RULES: "Reglas",
  CANCEL_DATE: "Cancelar",
  OK_DATE: "Aceptar",
  STATE: "state",
  COLLECTION_NAME: "collectionName",
  CONDITIONS: "conditions",
  PAGE_TITLE_ADD: "Agregar regla",
  PAGE_TITLE_EDIT: "Editar regla",
  PAGE_TITLE_SEARCH: "Consulta de reglas",
  PAGE_TITLE: "Reglas",
  TITTLES: {
    CHANGE_SERVICE_STATE: "Cambiar estado del servicio",
    CHANGE_MEDICAL_ORDER: "Modificar orden médica"
  },
  VALIDATE_USER: "Validar usuario",
  TABS: { CONDICIONES: "CONDICIONES", ACCIONES: "ACCIONES" },
  STOP_CONDITION_ALERT:
    "No se pueden configurar condiciones de parada a acciones inmediatas o no frecuentes",
  NO_DATA_LIST: "No se encontro información",
  SELECTED: "Seleccionados",
  SEARCH_SERVICE: "Buscar servicio",
  COLLECTIONS_REQUIRE_SERVICE: ["Usuario", "Tarea"],
  TOOLTIP: {
    EDIT: "Editar acción",
    DELETE: "Eliminar acción",
    STOP_CONDITION_TOOLTIP: "Condiciones de parada",
    CANCEL: "Cancelar",
    SAVE: "Guardar",
    GO_TO_START: "Ir al inicio",
    ADD_CONDITION: "Agregar condición",
    DELETE_CONDITION: "Eliminar condición",
    INNER_CONDITION: "Agregar condición mas interna",
    TEMPLATE_CONDITION: "Seleccione una plantilla",
    EXECUTE_RULES_NOTIFICACION: "Condiciones de ejecucion"
  },
  EMITTERS: {
    SEND_ACTIONS_TO_SAVE: "sendActionsToSave",
    DISABLED_SAVE_BUTTON: "disableSaveButton",
    SEND_COLLECTION: "sendCollection",
    DISABLE_BUTTON: "disableSaveButton",
    SEND_CONDITION_TO_SAVE: "sendConditionsToSave",
    ACTIVE_RULE: "activeRule",
    SEND_VALUE: "sendValue",
    SET_CLIENTS_CUPS: "setClientsCups",
    SAVE_ORDER_ACTION: "saveOrderAction",
    SAVE_TASK_ACTION: "saveTaskAction",
    CLOSE_MODAL: "closeModal",
    SEND_CUSTOM_FIELDS: "sendCustomFields",
    SET_VALUE: "setValue",
    HANDLE_RULES: "handleRules",
    SAVE_STOP_CONDITIONS: "saveStopConditions",
    ADD_STOP_CONDITION: "addStopCondition",
    UPDATE_STOP_CONDITION: "updateStopCondition",
    DELETE_STOP_CONDITION: "deleteStopCondition",
    ENABLE_SAVE_BTN: "enableSaveBtn",
    DISABLE_SAVE_BTN: "disableSaveBtn",
    CLOSE_MODAL_GENERATE_DOCUMENT: "closeGenerateDocument",
    ACCEPT_MODAL_GENERATE_DOCUMENT: "acceptGenerateDocument",
    DELETE_SESSION_GROUPS_CONDITION: "deleteSessionGroupsConditions",
    SERVICE_TEMPLATES: "serviceTemplates",
    IS_VALID_RULE_NAME: "isValidName",
    LOAD_FORM_TEMPLATES: "loadFormTemplates",
    SAVE_NOTIFICATION_EXE_RULE: "notificationEXERule",
    SAVE_SERVICE_STATE_MODAL: "saveServiceStateModal",
    CLOSE_SERVICE_STATE_MODAL: "closeServiceStateModal",
    SAVE_CHANGE_MEDICAL_ORDER_MODAL: "saveChangeMedicalOrderModal",
    CLOSE_CHANGE_MEDICAL_ORDER_MODAL: "closeChangeMedicalOrderModal",
    ORDER_CUSTOM_CHANGE: "checkUpdate",
    CHECK_CONDITION_EDIT: "checkConditionEdit",
    CHECK_ACTION_EDIT: "checkActionEdit"
  },
  RULE_SAVE: "ruleSave",
  DELETE_CONDITION: "Eliminar condición.",
  MESSAGES: {
    NOT_FOUND_INFO_GROUPS: "El grupo de información no fue encontrado",
    CANCEL_MODAL: {
      MESSAGE: "¿Está seguro que desea cancelar?",
      TITLE: "Cancelar"
    },
    REQUIRED_TIME_UNIT: "Debe configurar rango de tiempo",
    SERVICES_OR_SESIONS:
      "Para crear una acción tipo órden se requiere crear las condiciones de tipo Servicio o Sesión.",
    JUST_ONE_ORDER_TYPE_ACTION: "Solo puedes agregar una acción de tipo Órden.",
    MUST_DELETE_LEVEL_PRICE:
      "Para eliminar Cups, primero debes eliminar nivel de precio",
    CHANGE_SERVICE_STATE_NOTE:
      "Al seleccionar la plantilla del servicio se cambiara el estado de todos los servcios pertenecientes a esa plantilla en los estados diferentes a CANCELADO Y COMPLETADO.",
    MUST_DELETE_ELAPSED_TIME:
      "Para eliminar Estado, primero debes eliminar tiempo transcurrido",
    MUST_HAVE_CUPS:
      "Para crear condición de nivel de precio primero debe haber una condición de cups",
    USER_DOES_NOT_EXIST: "Este usuario no existe",
    REQUEST_FAILED: "Ha ocurrido un error, intente más tarde.",
    REQUEST_SUCCESSFULLY: "Se ha guardado la regla.",
    DELETE_CONDITION_TEXT: "¿Esta seguro de eliminar esta condición?",
    DELETE_CONDITION_TITLE: "Eliminar Condición",
    EXIST_CONDITION: "Esta condición ya existe",
    MUST_BE_RANGE: "Debes seleccionar un rango de fechas",
    MUST_EXIST_ONE_CONDITION: "Debe existir al menos una condición",
    ENABLE_MODAL: {
      MESSAGE: "¿Está seguro que desea habilitar esta regla?",
      TITLE: "Habilitar regla"
    },
    DELETE_ACTION: {
      MESSAGE: "¿Esta seguro de eliminar esta acción?",
      TITLE: "Eliminar acción"
    },
    DISABLED_MODAL: {
      MESSAGE: "¿Está seguro que desea deshabilitar esta regla?",
      TITLE: "Deshabilitar regla"
    },
    DELETE_RULE: {
      MESSAGE: "¿Está seguro que desea eliminar esta regla?",
      TITLE: "Eliminar regla",
      USED: "La regla no puede ser eliminada porque está en uso."
    },
    DELETE_RESPONSE: "Se ha eliminado la regla con exito",
    DELETE_ALL_ACTIONS_TYPE: {
      MESSAGE: "¿Está seguro que desea eliminar todas la acciones del tipo ",
      TITLE: "Eliminar acciones"
    },
    REPET_TYPE_ACTION_CONTAINER: "Ya agregaste un campo de este tipo.",
    ACTION_ASSIGN_SERVICE_NOT_SHOW:
      "Para asignar servicio, la condición del estado de servicio no puede ser Sin asignar.",
    ACTION_BLOCKED_SAVE_ASSIGN_SERVICE:
      "No se puede asignar servicio cuando hay una condicion tipo servicio sin estado.",
    FIELD_DUPLICATE:
      "No se pueden guardar las concidiones porque existen campos duplicados",
    REQUIRED_STATE: "Debe configurar primero una condición para el estado",
    REQUIRED_CODEPENDENCY: "Se requiere primero una condicion de tipo ",
    ACTION_BLOCKED_CODEPENDENCY_REQ: "Se requiere primero eliminar el campo ",
    ACTION_BLOCKED_CODEPENDENCY_REQ_NOT_MULTIPLE:
      "se debe modificar primero el campo ",
    NOT_FOUND_ACTION_PLAN:
      "No se encontro ningún plan de acción con la categoria ",
    NOT_FOUND_CATEGORY: "No se encontro ninguna categoria con el nombre ",
    DOCUMENT_ALREADY_SET:
      "La acción que esta estableciendo ya se encuentra configurada",
    NOT_ASSIGN_SAME_SERVICE_OF_CONDITION:
      "No se puede asignar el mismo servicio seleccionado en las condiciones cuando hay una condición de tipo servicio con el estado Sin asignar."
  },
  EQUAL_OPERATOR: EQUAL_AND_INCLUDES_OPERATORS[0].operator,
  INCLUDE_OPERATOR: EQUAL_AND_INCLUDES_OPERATORS[1].operator,
  BELONGS_OPERATOR: BELONGS_OPERATOR.operator,
  TITLE_PAGE: "Reglas",
  STOP_CONDITIONS_TITLE: "Condiciones de parada",
  GENERATE_DOCUMENT: "Generación de documento",
  TITLE_BUTTON_SERVICES: "Seleccione colección",
  LABEL: {
    RULE_NAME: "Nombre de la regla*",
    DESCRIPTION: "Descripción*",
    SELECT_DATE: "Seleccione fecha",
    SELECT_SERVICE: "Seleccionar servicio",
    SELECT_SERVICE_STATE: "Seleccionar estado del servicio",
    SELECT_ORDER_STATE: "Seleccionar nuevo estado de la orden",
    CHANGE_STATE: "Cambiar estado"
  },
  ACTIONS_DROPDOWN: [
    "Órden",
    "Tareas",
    "Notificación",
    "Generar documento",
    "Formularios",
    "Asignar servicio",
    "Ejecutar RPA",
    "Cambiar estado de servicio",
    "Modificar orden médica",
    "Ejecutar RDA"
  ],
  DROPDOWN_SERVICES: [
    {
      key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.KEY,
      name: "Cita médica",
      fields: [
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.START_DATE.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.START_DATE.name,
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CREATED_DATE.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CREATED_DATE.name,
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.PATIENT.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.PATIENT.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.DOCTOR.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.DOCTOR.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SERVICE.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SERVICE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.STATE.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.STATE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CAMPUS.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CAMPUS.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SPACE.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.SPACE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CREATED_BY.key,
          field: FILTERS_NAMES_CONST.MEDICAL_APPOIMENT.FIELDS.CREATED_BY.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.SERVICE.KEY,
      name: "Servicio",
      fields: [
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.TYPE.key,
          field: "Tipo",
          operators: [EQUAL_OPERATOR],
          display: INPUT_TYPE.SELECT,
          value: SERVICE_TYPE,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.CATEGORY.key,
          field: "Categoría",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.USER.key,
          field: "Usuario",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.PROGRESS.key,
          field: "Progreso",
          operators: SEVERAL_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.key,
          field: "Plantilla (Nombre)",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.CUPS.key,
          field: "Cups",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.PRICE_LEVEL.key,
          field: "Nivel de precio",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.STATUS.key,
          field: "Estado",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: SERVICE_STATE_LIST,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.MODIFIED_DATE.key,
          field: "Fecha de modificación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SERVICE.FIELDS.COMPLETED_DATE.key,
          field: "Fecha de completado",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.USER.KEY,
      name: "Usuario",
      fields: [
        {
          key: FILTERS_NAMES_CONST.USER.FIELDS.STATUS.key,
          field: "Estado",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: USER_STATES,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.USER.FIELDS.USERTEMPLATE.key,
          field: "Plantilla (Nombre)",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.USER.FIELDS.DEPENDENCY.key,
          field: FILTERS_NAMES_CONST.USER.FIELDS.DEPENDENCY.name,
          operators: [BELONGS_OPERATOR],
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },

        {
          key: FILTERS_NAMES_CONST.USER.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.USER.FIELDS.MODIFIED_DATE.key,
          field: "Fecha de modificación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.FORM.KEY,
      name: "Formulario",
      fields: [
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.FORMTEMPLATE.key,
          field: "Plantilla",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.OWNER.key,
          field: FILTERS_NAMES_CONST.FORM.FIELDS.OWNER.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.SERVICE.key,
          field: "Servicio",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.CATEGORY.key,
          field: "Categoría",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: FORM_CATEGORY_LIST,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.FORM.FIELDS.COMPLETED_DATE.key,
          field: "Fecha de completado",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.TASK.KEY,
      name: "Tarea",
      fields: [
        USER_CONDITION,
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.FORMTEMPLATE.key,
          field: FILTERS_NAMES_CONST.TASK.FIELDS.FORMTEMPLATE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.NAME.key,
          field: FILTERS_NAMES_CONST.TASK.FIELDS.NAME.name,
          operators: [EQUAL_OPERATOR],
          display: INPUT_TYPE.TEXT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.STATUS.key,
          field: "Estado",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: STATUS_TASK,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.COMPLETED_DATE.key,
          field: "Fecha de completado",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.key,
          field: FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.name,
          operators: [BELONGS_OPERATOR],
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.ORDER.KEY,
      name: "Orden",
      fields: [
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.USER.key,
          field: "Usuario",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.STATUS.key,
          field: "Estado",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: ORDER_STATUS,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.PAYMENT_METHOD.key,
          field: "Tipo de facturación",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: BILLING_TYPE,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.CAMPUS.key,
          field: "Campus",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.PAYMENT.key,
          field: "Pago",
          operators: SEVERAL_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.DIAGNOSIS_CODE.key,
          field: "Código de diagnóstico",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.ORDER_TYPE.key,
          field: "Tipo de orden",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: ORDER_TYPES,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.CUPS.key,
          field: "Cups",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.PRICE_LEVEL.key,
          field: "Nivel de precio",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.ORDER.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        }
      ]
    },
    {
      key: FILTERS_NAMES_CONST.SESSION.KEY,
      name: "Sesión",
      fields: [
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.SESSIONTEMPLATE.key,
          field: FILTERS_NAMES_CONST.SESSION.FIELDS.SESSIONTEMPLATE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.STATUS.key,
          field: "Estado",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          value: SESION_STATUS_VALUES,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.OWNER.key,
          field: FILTERS_NAMES_CONST.SESSION.FIELDS.OWNER.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.SERVICE.key,
          field: "Servicio",
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.RATE.key,
          field: "Calificación",
          operators: SEVERAL_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: true
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.CREATED_DATE.key,
          field: "Fecha de creación",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.COMPLETED_DATE.key,
          field: "Fecha de completado",
          operators: SEVERAL_OPERATORS_AND_RANGE,
          display: INPUT_TYPE.DATE_PICKER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.TIME_ELAPSED.key,
          field: FILTERS_NAMES_CONST.TIME_ELAPSED.name,
          operators: TIME_ELAPSED_OPERATORS,
          display: INPUT_TYPE.NUMBER,
          showInStopConditios: false
        },
        {
          key: FILTERS_NAMES_CONST.SESSION.FIELDS.TIME_BETWEEN.key,
          field: FILTERS_NAMES_CONST.SESSION.FIELDS.TIME_BETWEEN.name,
          operators: OPERATORS_GREATHER_LESS_THAN,
          display: INPUT_TYPE.NUMBER,
          codependency: {
            fieldName: "Servicio",
            fieldValue: "",
            allowMultiple: false
          }
        }
      ]
    },

    {
      key: FILTERS_NAMES_CONST.LEAD.KEY,
      name: FILTERS_NAMES_CONST.LEAD.NAME,
      fields: [
        {
          key: FILTERS_NAMES_CONST.LEAD.FIELDS.TYPE.key,
          field: FILTERS_NAMES_CONST.LEAD.FIELDS.TYPE.name,
          operators: EQUAL_AND_INCLUDES_OPERATORS,
          display: INPUT_TYPE.SELECT,
          showInStopConditios: true
        }
      ]
    }
  ]
};

export const COLLECTIONS_CAN_CHANGE_MEDICAL_ORDER = [
  GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES[0].key,
  GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES[1].key,
  GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES[3].key
];

export const RULE_NEW: GeneralRule = {
  actions: [],
  collection: "",
  conditions: [],
  name: "",
  description: "",
  executionCount: 0,
  state: true
};

export const ACTIONS_TYPES = [
  {
    key: GENERAL_RULES_CONSTANTS.MEDICAL_ORDER,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[0]
  },
  {
    key: GENERAL_RULES_CONSTANTS.TASK,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[1]
  },
  {
    key: GENERAL_RULES_CONSTANTS.NOTIFICATION,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[2]
  },
  {
    key: GENERAL_RULES_CONSTANTS.DOCUMENTS,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[3]
  },
  {
    key: GENERAL_RULES_CONSTANTS.FORM,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[4]
  },
  {
    key: GENERAL_RULES_CONSTANTS.SERVICE,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[5]
  },
  {
    key: GENERAL_RULES_CONSTANTS.RPA,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[6]
  },
  {
    key: GENERAL_RULES_CONSTANTS.CHANGE_SERVICE_STATE_ACTION,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[7]
  },
  {
    key: GENERAL_RULES_CONSTANTS.CHANGE_MEDICAL_ORDER,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[8]
  },
  {
    key: GENERAL_RULES_CONSTANTS.RDA,
    name: GENERAL_RULES_CONSTANTS.ACTIONS_DROPDOWN[9]
  }
];

export const ID_LIST = {
  SERVICE_CATEGORY: "BPQCt1csjU5JBHjVP6pt",
  ORDER_STATE: "LE5NOLPoQNab9xbmecva",
  ORDER_CODE: "GNVJAkLSOPNkXtWqz7vA",
  CAMPUS: "uum9o3mQIKbu1LfIp9pH",
  DIAGNOSIS_CODE: "GNVJAkLSOPNkXtWqz7vA"
};

export const NO_MULTIPLE = " No multiple";

export const TIME_RELATED_FILTERS = [
  FILTERS_NAMES_CONST.SESSION.FIELDS.TIME_BETWEEN.name,
  FILTERS_NAMES_CONST.TIME_ELAPSED.name,
  FILTERS_NAMES_CONST.SERVICE.FIELDS.INACTIVITY_TIME.name
];

export const CHANGE_OPERATOR = { operator: "Cambie", key: "change" };
export const TIME_UNITS = [
  { label: "Hora(s)", value: "hour" },
  { label: "Dia(s)", value: "day" },
  { label: "Semana(s)", value: "week" },
  { label: "Mes(es)", value: "month" },
  { label: "Año(s)", value: "year" }
];

export const DEEP_LEVEL_COLLECTIONS_ALLOWED = ["Cups", "Plantilla", "Servicio"];

export const COLLECTIONS_MAP = [
  {
    attrValue: "Usuario",
    complex: {
      key: "Plantilla",
      complex: {
        key: "Grupos de información"
      }
    }
  },
  {
    attrValue: "Orden",
    complex: {
      key: "Cups"
    }
  },
  {
    attrValue: "Servicio",
    complex: {
      key: "Cups"
    }
  },
  {
    attrValue: "Formulario",
    complex: {
      key: "Plantilla"
    }
  },
  {
    attrValue: "Formulario",
    complex: {
      key: "Servicio",
      complex: {
        key: "Grupos"
      }
    }
  }
];

export const CONDITIONS_KEYS = ["key", "operation", "value"];

export const CUPS_KEY_OPS: RequestInnerInfo[] = [
  {
    from: "Cups",
    key: "requiredPriorOrder",
    value: "Requiere orden previa",
    operatorList: [
      {
        key: "'=='",
        name: "Igual a"
      },
      {
        key: "includes",
        name: "Dentro de"
      }
    ]
  }
];

export const USER_KEY_OPS = [
  {
    key: "infoGroups",
    value: "Grupo(s) de información",
    operatorList: [
      {
        key: "'=='",
        name: "Igual a"
      },
      {
        key: "includes",
        name: "Dentro de"
      }
    ]
  }
];

export const REQUIRED_ORDER_IN_CUPS: GenaralRuleField = {
  display: "select",
  field: "requiredPriorOrder",
  key: "requiredPriorOrder",
  operators: [],
  value: [
    {
      key: "True",
      name: "Si"
    },
    {
      key: "False",
      name: "No"
    }
  ]
};

export const KEY_LIST = "list";

export const CUPS_LOWER_CASE = FILTERS_NAMES_CONST.SERVICE.FIELDS.CUPS.key;

export const SELECT_TYPES = [
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.RADIO,
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.CHECKBOX,
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT
];

export const LIST_TYPES = [
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT,
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.RADIO
];

export const SAME_OPERATOR_LIST_TYPES = [
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.INPUT,
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER,
  FIELD_GROUP_CONSTANTS.FIELD_TYPE.SLIDER
];

export const LIST_OF_COLLECTIONS_WITH_INNER_CONDITIONS = [
  FILTERS_NAMES_CONST.ORDER.KEY,
  FILTERS_NAMES_CONST.SERVICE.KEY,
  FILTERS_NAMES_CONST.USER.KEY,
  FILTERS_NAMES_CONST.FORM.KEY
];

export const LIST_SAME_HANDLE_COLLECTIONS = [
  FILTERS_NAMES_CONST.ORDER.KEY,
  FILTERS_NAMES_CONST.SERVICE.KEY,
  FILTERS_NAMES_CONST.FORM.KEY
];

export const LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS = [
  FILTERS_NAMES_CONST.ORDER.KEY,
  FILTERS_NAMES_CONST.SERVICE.KEY
];

export const LIST_OF_COLLECTIONS_WITH_FIELDS_IN_FORMS = [
  FILTERS_NAMES_CONST.FORM.KEY,
  FILTERS_NAMES_CONST.USER.KEY
];

export const DELETE_INNER_INFO_GROUP_CONDITONS =
  "deleteInnerInfoGroupsConditions";

export const DELETE_INNER_CONDITONS = "deleteInnerCondition";

export const DELETE_DEEP_CONDITIONS = "deleteDeepCondition";

export const ADD_INNER_TO_ACCUMULATOR = "addInnerToAccumulator";

export const TYPE_OF_INNER_CONDITIONS = {
  SIMPLE: "simple",
  COMPLEX: "complex"
};

export const MODIFY_ENTRIES = {
  KEY: "modifyKey",
  OPERATION: "modifyOps",
  VALUE: "modifyValue"
};

export const INFO_GROUPS = "infoGroups";

export const SECOND_LEVEL = 2;

export const THIRD_LEVEL = 3;

export const STATES_ARRAY = ["Activo", "Inactivo"];

export const EQUAL_OPERATOR_KEY_NAME = {
  key: "'=='",
  name: "Igual a"
};

export const INCLUDES_OPERATOR_KEY_NAME = {
  key: "includes",
  name: "Dentro de"
};

export const GREATER_THAN_OPERATOR_KEY_NAME = { name: "Mayor que", key: ">" };
export const LESS_THAN_OPERATOR_KEY_NAME = { name: "Menor que", key: "<" };
export const BETWEEN_OPERATOR_KEY_NAME = { name: "Entre", key: "between" };
export const LESS_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME = {
  name: "Menor igual que",
  key: "<="
};
export const GREATER_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME = {
  name: "Mayor igual que",
  key: ">="
};

export const DATE_OPERATOR_KEY_NAME_ARRAY = [
  EQUAL_OPERATOR_KEY_NAME,
  BETWEEN_OPERATOR_KEY_NAME,
  GREATER_THAN_OPERATOR_KEY_NAME,
  LESS_THAN_OPERATOR_KEY_NAME,
  LESS_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME
];

export const EQUAL_INCLUDES_OPERATORS_LIST = [
  EQUAL_OPERATOR_KEY_NAME,
  INCLUDES_OPERATOR_KEY_NAME
];

export const NUMBER_OPERATORS_LIST = [
  EQUAL_OPERATOR_KEY_NAME,
  LESS_THAN_OPERATOR_KEY_NAME,
  LESS_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME,
  GREATER_THAN_OPERATOR_KEY_NAME,
  GREATER_THAN_OR_EQUALS_TO_OPERATOR_KEY_NAME,
  BETWEEN_OPERATOR_KEY_NAME
];

export const SET_INNER_CONDITIONS = "setInnerConditions";

export const SET_THIRD_LEVEL_INNER_CONDITIONS = "setInnerConditionsThirdLevel";

export const FORM_TEMPLATE = "formTemplate";

export const USER_TEMPLATE = "userTemplate";

export const INNER_CONDITIONS = "innerConditions";

export const CONDITIONS = "conditions";

export const KEY = "key";

export const KEYS_OF_USER_TEMPLATE_FORMS = {
  TEMPLATE: "Plantilla",
  FORM_TEMPLATE: FILTERS_NAMES_CONST.TASK.FIELDS.FORMTEMPLATE.name,
  USER: "Usuario",
  FORMS: "Formulario",
  TASK: FILTERS_NAMES_CONST.TASK.NAME,
  SERVICIO: "Servicio"
};

export const INFO_GROUPS_LABEL = "Grupo(s) de información";

export const DATE_LABEL = "date";

export const ADD_CONDITION_DEEP_LEVEL = "Adicionar condición";

export const RULES_ACCESS = {
  GET: "consultar reglas",
  POST: "crear reglas",
  PUT: "modificar reglas",
  UPDATE: "actualizar reglas",
  DELETE: "eliminar reglas"
};

export const ESCHEMA_TYPES = {
  STRING: "string",
  ARRAY: "array",
  NUMBER: "number",
  BOOLEAN: "boolean",
  OBJECT: "object",
  LIST: "lista"
};

export const LABEL_DOCUMENT_TYPES = {
  DOCUMENT_TYPE: "Seleccione tipo de documento",
  CATEGORY_LABEL: "Seleccione categoria",
  DOCUMENT_CATEGORY_LABEL: "Seleccione el documento"
};

export const DOCUMENT_TYPE_DEFAULT = {
  id: "Plan de acción",
  name: "Plan de acción"
};

export const LABEL_SLIDER = {
  minimum: "minimum",
  maximum: "maximum",
  step: "step"
};

export const NOTIFICATION_EXE_RULES_FIELDS = [
  {
    key: FILTERS_NAMES_CONST.SERVICE.FIELDS.INACTIVITY_TIME.key,
    field: FILTERS_NAMES_CONST.SERVICE.FIELDS.INACTIVITY_TIME.name,
    operators: TIME_ELAPSED_OPERATORS,
    display: INPUT_TYPE.NUMBER,
    showInStopConditios: false,
    codependency: {
      fieldName: "Tipo",
      fieldValue: "Grupos",
      allowMultiple: false
    }
  },
  {
    key: FILTERS_NAMES_CONST.SERVICE.FIELDS.TIME_LAST_SESSION.key,
    field: FILTERS_NAMES_CONST.SERVICE.FIELDS.TIME_LAST_SESSION.name,
    operators: OPERATORS_GREATHER_LESS_THAN,
    display: INPUT_TYPE.NUMBER,
    showInStopConditios: false
  }
];

export const TIME_RELATED_FILTERS_NOTIFICATION_EXE = NOTIFICATION_EXE_RULES_FIELDS.map(
  e => e.key
);

export const SEND_TIME_UNIT_EXE_NOTIFICATION = "updateTimeUnit";

export const LEVELS_GROUPS_STATES = [
  {
    key: "En progreso",
    name: "En progreso"
  },
  {
    key: "Completado",
    name: "Completado"
  }
];

export const COLLECTIONS_WITHOUT_SERVICES = [
  FILTERS_NAMES_CONST.TASK.KEY,
  FILTERS_NAMES_CONST.USER.KEY
];

export const SERVICE_FIELDS = {
  TEMPLATE: "serviceTemplate",
  STATE: "state"
};

export const RULES_COLLECTIONS = {
  SERVICES: "services"
};
